import * as React from "react";

interface ChartErrorSvgProps {
  width: number;
  height: number;
  id: string;
  small?: boolean;
}

export const ChartErrorSvg = ({ width, height, id, small = false }: ChartErrorSvgProps) => {
  return (
    <div className="ChartErrorSvg">
      <svg width={width} height={height} id={id}>
        <text fill="red" fontSize={small ? "14" : "16"} x={small ? "50" : "20"} y="30">Data Parsing Error</text>
        <text fill="red" fontSize={small ? "10" : "12"} x={small ? "50" : "20"} y="60">This test contains invalid data.</text>
        <text fill="red" fontSize={small ? "10" : "12"} x={small ? "50" : "20"} y="75">Consider rejecting this test.</text>
      </svg>
    </div>
  )
}